import React from "react";

import Card from "react-bootstrap/Card";
import { IoCheckmarkDone } from "react-icons/io5";

import { NavLink } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";

export default function PlanDay({ planDay, n_week, n_day, isLocked, width = 250 }) {
  const abbreviateTitle =
    planDay.workout.name.length > 24
      ? planDay.workout.name.slice(0, 24) + "..."
      : planDay.workout.name;
  const toUrl = isLocked
    ? ""
    : "/workout/" + planDay.id + "/" + planDay.workout.id + "/0/0/Content#" + n_week + "_" + n_day;

  return (
    <NavLink
      id={n_week + "_" + n_day}
      to={toUrl}
      className="text-centers align-self-center"
      style={{ textDecoration: "none" }}
    >
      <Card
        style={{
          width: width,
          maxWidth: "100%",
          border: "unset",
          borderRadius: "20px",
          opacity: planDay.done ? 0.5 : 1
        }}
        className="text-center workout-card"
      >
        {planDay.done ? (
          <IoCheckmarkDone
            style={{ position: "absolute", top: 8, right: 8, background: PALETTE.LINEARGRADIENT }}
            color={PALETTE.WHITE}
            className="shadow-sm rounded-circle blur p-1"
            size={24}
          />
        ) : (
          <IoCheckmarkDone
            size={24}
            className="shadow-sm rounded-circle blur p-1"
            color={PALETTE.DARKGRAY}
            style={{ position: "absolute", top: 8, right: 8 }}
          />
        )}
        <Card.Img
          src={planDay.workout.cover}
          alt={planDay.workout.name}
          style={{
            objectFit: "cover",
            height: width,
            borderRadius: "20px",
          }}
        />
        <Card.Body
          className="text-start px-1 rounded"
          style={{
            color: PALETTE.GRAY,
            paddingTop: 4,
            paddingBottom: 4,
          }}
        >
          <p style={{ color: PALETTE.DARK, marginBottom: 8, marginTop: 8 }}>
            {abbreviateTitle}
          </p>
          <span className="my-0 rounded-md px-2 py-1" style={{ fontSize: 12, background: PALETTE.LIGHTGRAY, marginRight: 8 }}>
            {`Livello ${planDay.workout.level}`}
          </span>
          <span className="my-0 rounded-md px-2 py-1" style={{ fontSize: 12, background: PALETTE.LIGHTGRAY }}>
            {`Durata ${planDay.workout.duration}'`}
          </span>
        </Card.Body>
      </Card>
    </NavLink>
  );
}
